import { render, staticRenderFns } from "./Letreiros.vue?vue&type=template&id=2cfc8b1b&scoped=true&"
import script from "./Letreiros.vue?vue&type=script&lang=js&"
export * from "./Letreiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc8b1b",
  null
  
)

export default component.exports